import React from 'react'
import Svg from '../../Svg'

const SmsHB = () => (
  <Svg viewBox='0 0 192 87' fill='none' xmlns='http://www.w3.org/2000/svg'>
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M35.2906 0C26.8458 0 20 6.84582 20 15.2906V71.7094C20 72.9315 20.1434 74.1202 20.4142 75.2594C20.4204 76.747 20.4259 78.036 20.4259 78.036C20.4259 81.8127 18.2034 85.0624 15 86.573C18.8939 86.5015 22.5443 85.44 25.7134 83.6298C28.3343 85.7382 31.6651 87 35.2906 87H176.709C185.154 87 192 80.1542 192 71.7094V15.2906C192 6.84582 185.154 0 176.709 0H35.2906Z'
      fill='#535058'
    />
    <g opacity='0.6'>
      <rect x='57' y='21' width='113' height='7' rx='3.5' fill='#68646B' />
      <rect x='57' y='42' width='113' height='7' rx='3.5' fill='#68646B' />
      <rect x='57' y='61' width='94' height='7' rx='3.5' fill='#68646B' />
    </g>
    <path
      d='M42.7533 42.9431C42.7533 54.5126 33.4037 63.8863 21.8767 63.8863C10.3497 63.8863 1 54.5126 1 42.9431C1 31.3737 10.3497 22 21.8767 22C33.4037 22 42.7533 31.3737 42.7533 42.9431Z'
      fill='#302E35'
      stroke='#FC5AA6'
      strokeWidth='2'
    />
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M26.1802 45.3703C24.7228 45.3703 23.5412 44.1864 23.5412 42.7261C23.5412 41.2651 24.7235 40.0811 26.1802 40.0811C27.639 40.0811 28.8199 41.2651 28.8199 42.7261C28.8199 44.1864 27.639 45.3703 26.1802 45.3703ZM17.6165 45.3703C16.1584 45.3703 14.9768 44.1864 14.9768 42.7261C14.9768 41.2651 16.1584 40.0811 17.6165 40.0811C19.0747 40.0811 20.2562 41.2651 20.2562 42.7261C20.2562 44.1864 19.0747 45.3703 17.6165 45.3703ZM15.0623 52.4803H17.9492H25.8321H28.6964C29.6421 52.4803 30.4107 51.7108 30.4107 50.7625V47.8495H31.416C31.9269 47.8495 32.3406 47.435 32.3406 46.9245V43.184C32.3406 42.6728 31.9269 42.259 31.416 42.259H30.4107V38.591C30.4107 37.6434 29.6429 36.874 28.6964 36.874H22.3552V35.8441C23.6461 35.6364 24.6332 34.5159 24.6332 33.1636C24.6332 31.664 23.42 30.4492 21.9234 30.4492C20.4269 30.4492 19.2144 31.664 19.2144 33.1636C19.2144 34.4774 20.145 35.5722 21.3831 35.8237V36.874H15.0615C14.1158 36.874 13.3479 37.6426 13.3479 38.591V42.259H12.3291C11.819 42.259 11.406 42.6736 11.406 43.184V46.9245C11.406 47.435 11.8197 47.8495 12.3291 47.8495H13.3487V50.7625C13.3487 51.7108 14.1158 52.4803 15.0623 52.4803ZM15.612 48.8151C15.612 48.2628 16.0598 47.8151 16.612 47.8151H27.4225C27.9748 47.8151 28.4225 48.2628 28.4225 48.8151V49.0803C28.4225 49.6325 27.9748 50.0803 27.4225 50.0803H16.612C16.0598 50.0803 15.612 49.6325 15.612 49.0803V48.8151Z'
      fill='white'
    />
  </Svg>
)

export default SmsHB
